import { MoneyFormatter } from '@summit/models';

import { EboObjectTimeLine } from '../../base-classes/ebo-object-time-line';

export class StateWage extends EboObjectTimeLine {
  stateID: string;
  minimumWage: number;
  workersCompRate: number;

  constructor(jsonData: Partial<StateWage>) {
    super(jsonData);
  }

  toShortString(): string {
    return `${this.effectiveDate.format('M/D/YY')} - ${MoneyFormatter(this.minimumWage)}`;
  }
}
